/* ============================================================================
 * EnlightMeCenter — embeddable chat widget (self-hosted, single file)
 * Loads with one <script> tag. No dependencies. Brand: warm terracotta / rose + cream.
 *
 * Configure by defining window.EMC_CHAT_CONFIG before this script, or via
 * data- attributes on the <script> tag:
 *   <script src="https://YOUR-SERVER/widget.js"
 *           data-api="https://YOUR-SERVER/api/chat"></script>
 * ==========================================================================*/
(function () {
  'use strict';
  if (window.__emcChatLoaded) return;
  window.__emcChatLoaded = true;

  var script = document.currentScript || (function () {
    var s = document.getElementsByTagName('script'); return s[s.length - 1];
  })();

  var userCfg = window.EMC_CHAT_CONFIG || {};
  var cfg = {
    apiUrl: userCfg.apiUrl || (script && script.getAttribute('data-api')) ||
            'https://n8n.enlightme-app.fyi/webhook/emc-chat',
    brandName: userCfg.brandName || 'EnlightMeCenter',
    assistantName: userCfg.assistantName || 'Aura',
    supportEmail: userCfg.supportEmail || 'support@enlightmecenter.com',
    bookUrl: userCfg.bookUrl || 'https://enlightmecenter.com/products/book-an-appointment',
    greeting: userCfg.greeting ||
      "Hi, I'm Aura 🌿 Welcome to EnlightMeCenter. I can help you explore sessions, memberships, our shop, or Steanie's story. How can I support you today?",
    starters: userCfg.starters || [
      'What healing services do you offer?',
      "Tell me about the $600 Healing Conversations membership",
      'How do I book a session?',
      'Recommend a gift from the shop',
      'What is your return policy?'
    ]
  };

  // Palette matched to the EnlightMeCenter theme: warm terracotta / rose accent,
  // cream/blush surfaces, dark brand ink. Key names kept for minimal churn.
  var C = {
    navy: '#8f5040', navy2: '#a05948', purple: '#b06a58',
    gold: '#d18a7a', goldSoft: '#e6b3a4', ink: '#2b2b2b',
    bubbleUser: '#f6ddd4', panelBg: '#faf3ef', line: '#f0dcd3'
  };

  var history = []; // {role, content}

  // ---- styles --------------------------------------------------------------
  var css =
  '.emc-launch{position:fixed;left:20px;bottom:20px;z-index:2147483000;width:62px;height:62px;border:none;border-radius:50%;cursor:pointer;background:linear-gradient(135deg,'+C.navy2+','+C.purple+');box-shadow:0 8px 26px rgba(143,80,64,.4);display:flex;align-items:center;justify-content:center;transition:transform .15s ease}' +
  '.emc-launch:hover{transform:scale(1.06)}' +
  '.emc-launch svg{width:30px;height:30px}' +
  '.emc-badge{position:absolute;top:-3px;right:-3px;width:14px;height:14px;background:'+C.gold+';border-radius:50%;border:2px solid #fff}' +
  '.emc-panel{position:fixed;left:20px;bottom:94px;z-index:2147483000;width:380px;max-width:calc(100vw - 32px);height:600px;max-height:calc(100vh - 120px);background:'+C.panelBg+';border-radius:20px;overflow:hidden;display:none;flex-direction:column;box-shadow:0 18px 50px rgba(143,80,64,.35);font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;border:1px solid '+C.line+'}' +
  '.emc-open{display:flex}' +
  '.emc-head{background:linear-gradient(135deg,'+C.navy+' 0%,'+C.navy2+' 55%,'+C.purple+' 100%);color:#fff;padding:16px 18px;display:flex;align-items:center;gap:12px}' +
  '.emc-orb{width:38px;height:38px;border-radius:50%;background:radial-gradient(circle at 30% 30%,'+C.goldSoft+','+C.gold+');flex:0 0 auto;box-shadow:0 0 0 3px rgba(176,106,88,.28)}' +
  '.emc-htext{flex:1;min-width:0}' +
  '.emc-htitle{font-weight:700;font-size:15px;line-height:1.2}' +
  '.emc-hsub{font-size:11.5px;opacity:.85;display:flex;align-items:center;gap:5px;margin-top:2px}' +
  '.emc-dot{width:7px;height:7px;border-radius:50%;background:#7ee0a0;display:inline-block}' +
  '.emc-x{background:transparent;border:none;color:#fff;opacity:.8;cursor:pointer;font-size:20px;line-height:1;padding:4px}' +
  '.emc-x:hover{opacity:1}' +
  '.emc-body{flex:1;overflow-y:auto;padding:16px;background:'+C.panelBg+'}' +
  '.emc-msg{display:flex;margin-bottom:12px;gap:8px}' +
  '.emc-msg.user{justify-content:flex-end}' +
  '.emc-b{max-width:82%;padding:10px 13px;border-radius:14px;font-size:14px;line-height:1.5;white-space:pre-wrap;word-wrap:break-word}' +
  '.emc-msg.bot .emc-b{background:#fff;color:'+C.ink+';border:1px solid '+C.line+';border-top-left-radius:4px}' +
  '.emc-msg.user .emc-b{background:'+C.bubbleUser+';color:'+C.ink+';border-top-right-radius:4px}' +
  '.emc-b a{color:'+C.navy+';font-weight:600;text-decoration:underline}' +
  '.emc-starters{display:flex;flex-wrap:wrap;gap:8px;margin:2px 0 6px}' +
  '.emc-chip{background:#fff;border:1px solid '+C.line+';color:'+C.ink+';border-radius:16px;padding:8px 12px;font-size:12.5px;cursor:pointer;transition:all .12s ease;text-align:left}' +
  '.emc-chip:hover{border-color:'+C.purple+';background:'+C.bubbleUser+'}' +
  '.emc-cta{display:inline-block;margin-top:8px;background:linear-gradient(135deg,'+C.navy+','+C.navy2+');color:#fff;font-weight:700;font-size:13px;padding:9px 14px;border-radius:12px;text-decoration:none}' +
  '.emc-typing{display:flex;gap:4px;padding:4px 2px}' +
  '.emc-typing span{width:7px;height:7px;background:'+C.purple+';border-radius:50%;opacity:.4;animation:emcB 1s infinite}' +
  '.emc-typing span:nth-child(2){animation-delay:.2s}.emc-typing span:nth-child(3){animation-delay:.4s}' +
  '@keyframes emcB{0%,60%,100%{opacity:.3;transform:translateY(0)}30%{opacity:1;transform:translateY(-3px)}}' +
  '.emc-foot{border-top:1px solid '+C.line+';padding:10px;background:#fff}' +
  '.emc-inrow{display:flex;gap:8px;align-items:flex-end}' +
  '.emc-ta{flex:1;resize:none;border:1px solid '+C.line+';border-radius:12px;padding:10px 12px;font-size:14px;font-family:inherit;max-height:96px;outline:none;color:'+C.ink+'}' +
  '.emc-ta:focus{border-color:'+C.purple+'}' +
  '.emc-send{background:linear-gradient(135deg,'+C.navy2+','+C.purple+');border:none;border-radius:12px;width:42px;height:42px;flex:0 0 auto;cursor:pointer;display:flex;align-items:center;justify-content:center}' +
  '.emc-send:disabled{opacity:.5;cursor:default}.emc-send svg{width:20px;height:20px}' +
  '.emc-tag{text-align:center;font-size:10.5px;color:#96705f;margin-top:6px}' +
  '.emc-tag a{color:#96705f}';

  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  // ---- helpers -------------------------------------------------------------
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  // Escape, then linkify URLs and **bold**.
  function fmt(text) {
    var s = esc(text);
    s = s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>');
    s = s.replace(/(^|[^"'>=])(https?:\/\/[^\s<]+[^\s<.,)])/g,
      '$1<a href="$2" target="_blank" rel="noopener">$2</a>');
    return s;
  }

  // ---- build DOM -----------------------------------------------------------
  var launch = el('button', 'emc-launch');
  launch.setAttribute('aria-label', 'Open ' + cfg.brandName + ' chat');
  launch.innerHTML = '<span class="emc-badge"></span>' +
    '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>';

  var panel = el('div', 'emc-panel');
  panel.innerHTML =
    '<div class="emc-head"><div class="emc-orb"></div>' +
    '<div class="emc-htext"><div class="emc-htitle">' + esc(cfg.brandName) + '</div>' +
    '<div class="emc-hsub"><span class="emc-dot"></span>' + esc(cfg.assistantName) + ' · usually replies instantly</div></div>' +
    '<button class="emc-x" aria-label="Close">&times;</button></div>' +
    '<div class="emc-body"></div>' +
    '<div class="emc-foot"><div class="emc-inrow">' +
    '<textarea class="emc-ta" rows="1" placeholder="Ask about sessions, the shop, policies…"></textarea>' +
    '<button class="emc-send" aria-label="Send"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg></button>' +
    '</div><div class="emc-tag">Spiritual wellness support · not medical care · <a href="mailto:' + esc(cfg.supportEmail) + '">' + esc(cfg.supportEmail) + '</a></div></div>';

  document.body.appendChild(launch);
  document.body.appendChild(panel);

  var body = panel.querySelector('.emc-body');
  var ta = panel.querySelector('.emc-ta');
  var sendBtn = panel.querySelector('.emc-send');
  var greeted = false;

  function scrollDown() { body.scrollTop = body.scrollHeight; }

  function addMsg(role, text, opts) {
    opts = opts || {};
    var wrap = el('div', 'emc-msg ' + (role === 'user' ? 'user' : 'bot'));
    var b = el('div', 'emc-b'); b.innerHTML = fmt(text);
    if (opts.cta) {
      var a = el('a', 'emc-cta'); a.href = cfg.bookUrl; a.target = '_blank'; a.rel = 'noopener';
      a.textContent = '📅 Book a session'; b.appendChild(document.createElement('br')); b.appendChild(a);
    }
    wrap.appendChild(b); body.appendChild(wrap); scrollDown();
  }

  function addStarters() {
    var box = el('div', 'emc-starters');
    cfg.starters.forEach(function (q) {
      var chip = el('button', 'emc-chip', esc(q));
      chip.addEventListener('click', function () { box.remove(); send(q); });
      box.appendChild(chip);
    });
    body.appendChild(box); scrollDown();
  }

  function typing(on) {
    var ex = body.querySelector('.emc-typing-wrap');
    if (on) {
      if (ex) return;
      var w = el('div', 'emc-msg bot emc-typing-wrap');
      w.innerHTML = '<div class="emc-b"><div class="emc-typing"><span></span><span></span><span></span></div></div>';
      body.appendChild(w); scrollDown();
    } else if (ex) { ex.remove(); }
  }

  // Show the CTA when the reply is about booking/sessions/memberships.
  function wantsCta(text) {
    return /book|session|consultation|membership|appointment|healing|transformation/i.test(text);
  }

  async function send(text) {
    text = (text || ta.value).trim();
    if (!text) return;
    ta.value = ''; ta.style.height = 'auto'; sendBtn.disabled = true;
    addMsg('user', text);
    history.push({ role: 'user', content: text });
    typing(true);
    try {
      var r = await fetch(cfg.apiUrl, {
        method: 'POST', headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ messages: history })
      });
      var data = await r.json();
      typing(false);
      var reply = data.reply || ("I'm not certain about that. Please reach us at " + cfg.supportEmail + '.');
      addMsg('bot', reply, { cta: wantsCta(reply) && wantsCta(text) });
      history.push({ role: 'assistant', content: reply });
    } catch (e) {
      typing(false);
      addMsg('bot', "I'm having trouble connecting right now. Please email us at " + cfg.supportEmail + " and we'll help you personally. 🌿");
    } finally {
      sendBtn.disabled = false; ta.focus();
    }
  }

  function openPanel() {
    panel.classList.add('emc-open');
    launch.style.display = 'none';
    if (!greeted) { greeted = true; addMsg('bot', cfg.greeting); addStarters(); }
    setTimeout(function () { ta.focus(); }, 60);
  }
  function closePanel() {
    panel.classList.remove('emc-open'); launch.style.display = 'flex';
    emcAutoDone = true;
    try { sessionStorage.setItem('emcAutoOpened', '1'); } catch (e) {}
    cleanupTriggers();
  }

  launch.addEventListener('click', function () {
    emcAutoDone = true;
    try { sessionStorage.setItem('emcAutoOpened', '1'); } catch (e) {}
    cleanupTriggers();
    openPanel();
  });
  panel.querySelector('.emc-x').addEventListener('click', closePanel);
  sendBtn.addEventListener('click', function () { send(); });
  ta.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); }
  });
  ta.addEventListener('input', function () {
    ta.style.height = 'auto'; ta.style.height = Math.min(ta.scrollHeight, 96) + 'px';
  });

  // ---- Engagement-based auto-open (no pop-on-load) --------------------------
  // Opens ONCE per browser session when the visitor shows interest (scroll depth
  // or dwell) or seems lost (exit-intent on desktop, or idle after scrolling).
  // Fully dismissible: once opened or closed, it never auto-opens again this session.
  // Tunable thresholds:
  var EMC_TRIGGERS = {
    scrollDepthPct: 50,        // open after scrolling past this % of the page (interest)
    dwellMs: 45000,            // ...or after being on the page this long (interest)
    idleAfterScrollMs: 25000,  // "seems lost": idle this long after having scrolled
    exitIntent: true           // desktop only: open when the mouse leaves via the top
  };

  var emcAutoDone = false;     // true once opened OR dismissed -> no more auto-opens
  try { if (sessionStorage.getItem('emcAutoOpened') === '1') emcAutoDone = true; } catch (e) {}

  var _emcTimers = [], _emcHasScrolled = false, _emcIdleTimer = null, _emcStarted = false;

  function cleanupTriggers() {
    _emcTimers.forEach(function (t) { clearTimeout(t); }); _emcTimers = [];
    if (_emcIdleTimer) { clearTimeout(_emcIdleTimer); _emcIdleTimer = null; }
    window.removeEventListener('scroll', onEmcScroll);
    document.removeEventListener('mouseout', onEmcMouseOut);
  }

  function emcAutoOpen() {
    if (emcAutoDone || panel.classList.contains('emc-open')) return;
    emcAutoDone = true;
    try { sessionStorage.setItem('emcAutoOpened', '1'); } catch (e) {}
    cleanupTriggers();
    openPanel();
  }

  function emcScrolledPct() {
    var h = document.documentElement;
    var max = h.scrollHeight - h.clientHeight;
    if (max <= 0) return 0;
    return ((window.pageYOffset || h.scrollTop) / max) * 100;
  }

  function armIdle() {
    if (!_emcHasScrolled) return;
    if (_emcIdleTimer) clearTimeout(_emcIdleTimer);
    _emcIdleTimer = setTimeout(emcAutoOpen, EMC_TRIGGERS.idleAfterScrollMs);
  }

  function onEmcScroll() {
    _emcHasScrolled = true;
    if (emcScrolledPct() >= EMC_TRIGGERS.scrollDepthPct) { emcAutoOpen(); return; }
    armIdle();
  }

  function onEmcMouseOut(e) {
    if (!EMC_TRIGGERS.exitIntent) return;
    if (e.clientY <= 0 && !e.relatedTarget && !e.toElement) emcAutoOpen();
  }

  function startTriggers() {
    if (_emcStarted || emcAutoDone) return;
    _emcStarted = true;
    _emcTimers.push(setTimeout(emcAutoOpen, EMC_TRIGGERS.dwellMs));
    window.addEventListener('scroll', onEmcScroll, { passive: true });
    document.addEventListener('mouseout', onEmcMouseOut);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    startTriggers();
  } else {
    window.addEventListener('DOMContentLoaded', startTriggers);
  }
})();
